import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSelectAllComponent = ({
  selectEverything,
  totalRowCount
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "select-query-button",
    use: "link",
    onClick: selectEverything,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.bulkActions.selectQuery",
      options: {
        count: totalRowCount
      }
    })
  });
};
export default DefaultSelectAllComponent;